import { render, staticRenderFns } from "./Recommend01.vue?vue&type=template&id=2ded046f&"
import script from "./Recommend01.vue?vue&type=script&lang=js&"
export * from "./Recommend01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports